import _ from 'lodash';
import { checkIfMainTestInThisWeek, checkIfTestInThisPhase } from '../../helpers/helpers';
import { getPhaseIndex, isTestPresentInArray } from '../coursePlan/addTestDialog/AddScheduledTestOnGoals/helpers';
import { returnPhasesOfTree, makeArrayOfSubjects, returnArrayOfNames, rebuildSubjectsArray } from './index';

const returnArrayOfChildren = (parentArray: any) => {
  let arrayOfAllChildren: any = [];
  parentArray.subjects.forEach((primarySubject: any) => {
    if (!arrayOfAllChildren.includes(primarySubject.name)) arrayOfAllChildren.push(primarySubject);
  });
  return arrayOfAllChildren;
};

export const mergingTrees = (nonPrimaryTreePhaseArray: any, primaryTree: any, packageStartDate: string, packageEndDate: string, packageData: any) => {
  console.log({ primaryTree });
  const cloneNonPrimaryTreePhaseArray = { ...nonPrimaryTreePhaseArray }
  
  
  let mergedTreeData = JSON.parse(JSON.stringify(primaryTree));
  let arrayOfAllPrimarySubjectNames: any = [];
  let arrayOfAllPrimaryConceptNames: any = [];
  let arrayOfAllPrimaryChapterNames: any = [];
  let primaryPhases = returnPhasesOfTree(primaryTree);
  let newCount: number = 0;
  let updatedPrimaryChapters: any = [];
  let conflictedWeekData: any = [];
  let updatedConflictSubject: any = [];
  let conflictedPhase: any = {};

  primaryPhases.forEach((phase: any) => {
    phase.weeks.forEach((week: any) => {
      week.subjects.forEach((subject: any) => {
        if (!arrayOfAllPrimarySubjectNames.includes(subject.name)) {
          arrayOfAllPrimarySubjectNames.push(subject.name);
        }
        subject.chapters.forEach((chapter: any) => {
          if (!arrayOfAllPrimaryChapterNames.includes(chapter.name)) {
            arrayOfAllPrimaryChapterNames.push(chapter.name);
            ++newCount;
            updatedPrimaryChapters.push(chapter.name);
          }
          chapter.concepts.forEach((concept: any) => {
            if (!arrayOfAllPrimaryConceptNames.includes(concept.name)) arrayOfAllPrimaryConceptNames.push(concept.name);
          });
        });
      });
    });
  });

  primaryPhases.forEach((primaryPhase: any, primaryPhaseIndex: any) => {
    let arrayOfAllPrimarySubjectNamesInAPhase: any = [];
    let countOfPrimaryWeeksInAPhase: any = 0;
    countOfPrimaryWeeksInAPhase = primaryPhase.weeks.length;
    let arrayOfMilestoneName: any = [];
    let updatedMilestoneTests: any = [];
    let arrayOfAllChaptersInAPhase: any = [];

    primaryPhase.weeks.forEach((primaryWeek: any, primaryWeekIndex: any) => {
      primaryWeek.subjects.forEach((primarySubject: any) => {
        if (!arrayOfAllPrimarySubjectNamesInAPhase.includes(primarySubject.name))
          arrayOfAllPrimarySubjectNamesInAPhase.push(primarySubject.name);
        primarySubject.chapters.forEach((primaryChapter: any) => {
          if (!arrayOfAllChaptersInAPhase.includes(primaryChapter.name))
            arrayOfAllChaptersInAPhase.push(primaryChapter.name);
        });
      });
    });
    
    updatedMilestoneTests = [...primaryPhase.milestoneTests];
    primaryPhase.weeks.forEach((primaryWeek: any, primaryWeekIndex: any) => {
      let arrayOfAllPrimarySubjectsInAWeek: any = [];
      arrayOfAllPrimarySubjectsInAWeek = returnArrayOfChildren(primaryWeek);
      let updatedSubjects: any = [];
      primaryWeek.subjects.forEach((primarySubject: any) => {
        nonPrimaryTreePhaseArray.forEach((nonPrimaryTree: any, nonPrimaryTreeIndex: any) => {
          const cloneNonPrimaryTree = { ...nonPrimaryTree }
          let nonPrimaryPhases = returnPhasesOfTree(nonPrimaryTree);
          
          nonPrimaryPhases.forEach((nonPrimaryPhase: any, nonPrimaryPhaseIndex: any) => {
            
            nonPrimaryPhase.milestoneTests.forEach((nonPrimaryMilestoneTest: any) => {
              primaryPhase.milestoneTests.forEach((milestoneTest: any) => {
                
                if (!(milestoneTest.key === 'nonPrimary') || milestoneTest.key === undefined) {
                  
                  if ( ( ( milestoneTest.startDate  != null && nonPrimaryMilestoneTest.startDate  != null ) && (  milestoneTest.endDate != null && nonPrimaryMilestoneTest.endDate != null ) ) && 
                     ( ( new Date( milestoneTest.startDate ).getTime( ) === new Date( nonPrimaryMilestoneTest.startDate ).getTime( ))  || 
                  ( new Date( milestoneTest.endDate ).getTime( ) === new Date( nonPrimaryMilestoneTest.endDate ).getTime( ) ))
                  ) {
                    let conflictedMilestoneTest = { key: 'nonPrimary', conflict: true, ...nonPrimaryMilestoneTest };
                    let arrayOfConflictedMilestoneTest: any = [];
                    let primaryMilestoneTests = returnArrayOfNames(updatedMilestoneTests);
                    let arrayOfConflictMilestoneName: any = [];
                    arrayOfConflictMilestoneName = [...primaryMilestoneTests];
                    if (!arrayOfConflictMilestoneName.includes(conflictedMilestoneTest.name))
                      arrayOfConflictedMilestoneTest.push(conflictedMilestoneTest);
                    updatedMilestoneTests = [...updatedMilestoneTests, ...arrayOfConflictedMilestoneTest];
                  }
                }
                
              });

              let primaryMilestoneTests = returnArrayOfNames(updatedMilestoneTests);
              
              arrayOfMilestoneName = [...primaryMilestoneTests];
              
              if (
                !arrayOfMilestoneName.includes(nonPrimaryMilestoneTest.name)
              ) {
                let newMilestoneTest: any = [];
                newMilestoneTest.push({ key: 'nonPrimary', ...nonPrimaryMilestoneTest });
                updatedMilestoneTests = [...updatedMilestoneTests, ...newMilestoneTest];
              }
            });
            
            if (primaryPhaseIndex === nonPrimaryPhaseIndex) {
              let conflictedWeek: any = {};
              nonPrimaryPhase.weeks.forEach((nonPrimaryWeek: any, nonPrimaryWeekIndex: any) => {
  

                nonPrimaryWeek.subjects.forEach((nonPrimarySubject: any) => {
                  if (arrayOfAllPrimarySubjectNamesInAPhase.includes(nonPrimarySubject.name)) {
                    let conflictedChapters: any = [];
                    let arrayOfAllPrimaryChapters: any = [];

                    if (primarySubject.name === nonPrimarySubject.name 
                      
                      ) {


                   

                      primarySubject.chapters.forEach((primaryChapter: any) => {
                        if (!arrayOfAllPrimaryChapterNames.includes(primaryChapter.name))
                          arrayOfAllPrimaryChapterNames.push(primaryChapter.name);
                        if (!arrayOfAllPrimaryChapters.includes(primaryChapter))
                          arrayOfAllPrimaryChapters.push(primaryChapter);
                        primaryTree.subjects.forEach((primaryTreeSubject: any) => {
                          if (primaryTreeSubject.name === primaryChapter) primaryTreeSubject.chapterCount += 1;
                        });
                      });

                      
                      nonPrimarySubject.chapters.forEach((nonPrimaryChapter: any) => {
                       
                   

                        if (arrayOfAllChaptersInAPhase.includes(nonPrimaryChapter.name)) {
                          let arrayOfAllPrimaryConceptsInAChapterNames: any[] = [];
                          let arrayOfAllPrimaryConceptsInAChapter: any[] = [];

                          primarySubject.chapters.forEach((primaryChapter: any) => {
                            if (primaryChapter.name === nonPrimaryChapter.name) {
                              primaryChapter.concepts.forEach((primaryConcept: any) => {
                                if (!arrayOfAllPrimaryConceptsInAChapterNames.includes(primaryConcept.name))
                                  arrayOfAllPrimaryConceptsInAChapterNames.push(primaryConcept.name);
                                if (!arrayOfAllPrimaryConceptsInAChapter.includes(primaryConcept))
                                  arrayOfAllPrimaryConceptsInAChapter.push(primaryConcept);
                              });
                            }
                          });
                          nonPrimaryChapter.concepts.forEach((nonPrimaryConcept: any) => {
                            if (arrayOfAllPrimaryConceptsInAChapterNames.includes(nonPrimaryConcept.name)) {
                              const concept = arrayOfAllPrimaryConceptsInAChapter.find(({ name }) => name === nonPrimaryConcept.name);
                              if(concept) {
                                const setOfPrimaryConceptContentId = new Set(concept.content.map(({ contentId }: any) => contentId))
                                nonPrimaryConcept.content.forEach((contentData: any) => {
                                  if(!setOfPrimaryConceptContentId.has(contentData.contentId)) {
                                    concept.content.push(contentData)
                                  }
                                })
                              }
                            } else {
                              if(!arrayOfAllPrimaryConceptsInAChapter.find(({ name }: any) => name === nonPrimaryConcept.name)) {
                                arrayOfAllPrimaryConceptsInAChapter.push(nonPrimaryConcept);
                              }
                            }

                            if (!arrayOfAllPrimaryConceptNames.includes(nonPrimaryConcept.name)) {
                              arrayOfAllPrimaryConceptsInAChapter.push(nonPrimaryConcept);
                            }
                          });
                          const chapterToModify = arrayOfAllPrimaryChapters.find(({ id }: any) => id === nonPrimaryChapter.id);
                          if(chapterToModify) {
                            chapterToModify.concepts = arrayOfAllPrimaryConceptsInAChapter;
                            
                            const setOfChapterToModifyContentIds = new Set(chapterToModify.content.map(({ contentId }: any) => contentId));

                            nonPrimaryChapter.content.forEach((contentData: any) => {
                              if(!setOfChapterToModifyContentIds.has(contentData.contentId)) {
                                chapterToModify.content.push(contentData);
                              }
                            })
                          }

                        } else if (!arrayOfAllChaptersInAPhase.includes(nonPrimaryChapter.name)) {
                          if (primaryPhaseIndex === nonPrimaryPhaseIndex && primaryWeekIndex === nonPrimaryWeekIndex) {
                            if (!arrayOfAllPrimaryChapters.includes(nonPrimaryChapter))
                              arrayOfAllPrimaryChapters.push(nonPrimaryChapter);
                          } else {
                            if (!arrayOfAllPrimaryChapters.includes(nonPrimaryChapter))
                              conflictedChapters.push(nonPrimaryChapter);
                          }

                          let mockChapters = [...primarySubject.chapters];
                          mockChapters.forEach((mockChapter: any) => {
                            if (!arrayOfAllPrimaryChapterNames.includes(mockChapter))
                              arrayOfAllPrimaryChapterNames.push(mockChapter.name);
                          });
                        }
                        primarySubject.chapters = arrayOfAllPrimaryChapters;
                      });
                      
                    } else if(primarySubject.name === nonPrimarySubject.name){

                    }
                  } else if (
                    primaryPhaseIndex === nonPrimaryPhaseIndex &&
                    !arrayOfAllPrimarySubjectNamesInAPhase.includes(nonPrimarySubject.name)
                  ) {
                    primaryTree.subjects.push({
                      id: nonPrimarySubject.id,
                      name: nonPrimarySubject.name,
                      chapterCount: nonPrimarySubject.chapters.length,
                    });

                    if (primaryPhaseIndex === nonPrimaryPhaseIndex && primaryWeekIndex === nonPrimaryWeekIndex) {
                      if (!arrayOfAllPrimarySubjectsInAWeek.includes(nonPrimarySubject))
                        arrayOfAllPrimarySubjectsInAWeek.push(nonPrimarySubject);
                    }

                    if (
                      primaryPhaseIndex === nonPrimaryPhaseIndex &&
                      nonPrimaryWeekIndex + 1 > countOfPrimaryWeeksInAPhase
                    ) {
                      if (conflictedPhase.conflict === undefined || false) {
                        const demoConflictPhase: any = { conflict: true, ...primaryPhase };
                        demoConflictPhase.startDate = primaryPhases[primaryPhases.length - 1].startDate;
                        demoConflictPhase.endDate = primaryTree.endDate;
                        conflictedPhase = { ...demoConflictPhase };
                      }
                      if (!returnArrayOfNames(conflictedPhase.weeks).includes(nonPrimaryWeek.weekNo)) {
                        if (!returnArrayOfNames(conflictedWeekData).includes(nonPrimaryWeek.weekNo)) {
                          conflictedWeek = JSON.parse(JSON.stringify(nonPrimaryWeek));
                          conflictedWeek.subjects.forEach((subject: any) => {
                            updatedConflictSubject = subject.chapters.filter((chapter: any, chapterIndex: number) => {
                              return !arrayOfAllChaptersInAPhase.includes(chapter.name);
                              // subject.chapters.splice( chapterIndex, 1 )
                            });
                            subject.chapters = [...updatedConflictSubject];
                            
                          });
                          let updatedConflictWeek = { ...conflictedWeek };
                          conflictedWeekData.push(conflictedWeek);
                        }
                      }
                      conflictedPhase.weeks = [...conflictedWeekData];
                    }
                  }
                });
                primaryWeek.subjects = arrayOfAllPrimarySubjectsInAWeek;
              });
              primaryPhase.milestoneTests = updatedMilestoneTests;
              
            } else if (nonPrimaryPhaseIndex + 1 > primaryPhases.length) {
              nonPrimaryTreePhaseArray.forEach((nonPrimaryTree: any) => {
                let nonPrimaryPhases = returnPhasesOfTree(nonPrimaryTree);
                nonPrimaryPhases.forEach((nonPrimaryPhase: any, nonPrimaryPhaseIndex: any) => {
                  if (nonPrimaryPhaseIndex + 1 <= primaryPhases.length) {
                    nonPrimaryPhase.weeks.forEach((week: any) => {
                      week.subjects.forEach((subject: any) => {
                        if (!arrayOfAllPrimarySubjectNames.includes(subject.name)) {
                          arrayOfAllPrimarySubjectNames.push(subject.name);
                        }
                        subject.chapters.forEach((chapter: any) => {
                          if (!arrayOfAllPrimaryChapterNames.includes(chapter.name)) {
                            updatedPrimaryChapters.push(chapter.name);
                            arrayOfAllPrimaryChapterNames.push(chapter.name);
                            ++newCount;
                          }
                          chapter.concepts.forEach((concept: any) => {
                            if (!arrayOfAllPrimaryConceptNames.includes(concept.name))
                              arrayOfAllPrimaryConceptNames.push(concept.name);
                          });
                        });
                      });
                    });
                  }
                });
              });

              nonPrimaryPhase.weeks.forEach((nonPrimaryWeek: any) => {
                nonPrimaryWeek.subjects.forEach((nonPrimarySubject: any) => {
                  if (arrayOfAllPrimarySubjectNames.includes(nonPrimarySubject.name)) {
                    const existingChapters = nonPrimarySubject.chapters.filter((nonPrimaryChapter: any) => arrayOfAllPrimaryChapterNames.includes(nonPrimaryChapter.name));

                    const nonExistingChapters = nonPrimarySubject.chapters.filter((nonPrimaryChapter: any) => !arrayOfAllPrimaryChapterNames.includes(nonPrimaryChapter.name))

                    nonPrimarySubject.chapters = nonExistingChapters;

                    distributeChaptersOfASubject(primaryPhases, nonPrimarySubject.name, existingChapters);
                  }
                });
              });
              let newConflictedPhase = { conflict: true, ...nonPrimaryPhase };
              delete newConflictedPhase.milestoneTests;
              
              newConflictedPhase.milestoneTests = [];
                newConflictedPhase.subjects = [];

                buildSubjectArray( newConflictedPhase );
              let hasSyllabus: boolean = false;
              newConflictedPhase.subjects.forEach((subject:any)=>{
                if(subject.chapterCount != 0){
                  hasSyllabus = true
                  
                }
              })
              if( hasSyllabus ){
                const lastPhase = primaryPhases[ primaryPhases.length - 1 ]
                const lastEndDate = new Date( lastPhase.endDate )  
                const newEndDate = new Date( lastEndDate.setDate( lastEndDate.getDate(  ) + 1 ) );
                newConflictedPhase.startDate = newEndDate;
                const courseEndDate = new Date( primaryTree.endDate );
                newConflictedPhase.endDate = courseEndDate;
                primaryPhases.push(newConflictedPhase);
                  
                }
            }
            nonPrimaryPhase.weeks.forEach((nonPrimaryWeek: any) => {
              if (nonPrimaryWeek.conflict) {
                if (!conflictedWeekData.includes(nonPrimaryWeek)) conflictedWeekData.push(nonPrimaryWeek);
              }
            });
          });
        });
        conflictedPhase.weeks = conflictedWeekData;
      });
    });
  });

  if (conflictedPhase.name) {
    delete conflictedPhase.milestoneTests;
    
    conflictedPhase.milestoneTests = [];
    primaryPhases.push(conflictedPhase);
  }
  rebuildSubjectsArray(primaryTree.phases);

  primaryTree.subjects = [];
  const { phases } = primaryTree;
  phases.forEach((phase: any) => {
    phase.subjects.forEach((subject: any) => {
      const index = getIndex(primaryTree, subject.name);
      if (index === -1) {
        primaryTree.subjects.push(JSON.parse(JSON.stringify(subject)));
      } else {
        primaryTree.subjects[index].chapterCount += subject.chapterCount;
      }
    });
  });

  let milestoneTests:any[] = []
  milestoneTests = collectMilestoneTests(primaryPhases);
  milestoneTests.sort((test1, test2) => new Date(test1.startDate).getTime() - new Date(test2.startDate).getTime())
  if (milestoneTests.length) {
    distributeMilestoneTests(primaryPhases, milestoneTests, packageEndDate, packageData);
  }

  
  const allMainTests = collectMainOrExtraTests([...nonPrimaryTreePhaseArray.reduce((acc: any[], {phases}:any) => acc.concat(phases), []), ...primaryPhases], false);
  const allExtraTests = collectMainOrExtraTests([...nonPrimaryTreePhaseArray.reduce((acc: any[], {phases}:any) => acc.concat(phases), []), ...primaryPhases], true);
  distributeMainAndExtraTests(allMainTests, primaryPhases);
  allExtraTests.sort((test1, test2) => new Date(test1.startDate).getTime() - new Date(test2.startDate).getTime())
  distributeMainAndExtraTests(allExtraTests, primaryPhases);
  
  return { ...primaryTree, totalPhases: phases.length };
};

const distributeChaptersOfASubject = (phases: any[], subjectName: string, chapters: any[]) => {
  phases.forEach((phase: any) => {
    phase.weeks.forEach((week: any) => {
      const matchingSubject = week.subjects.find(({ name }: any) => name === subjectName);
      if(!matchingSubject) {
        return;
      }
      chapters.forEach(chapter => {
        const matchingChapter = matchingSubject.chapters.find(({ name }: any) => name === chapter.name);
        if(!matchingChapter) {
          matchingSubject.chapters.push(chapter);
          return;
        }
        // Merge chapter level content
        matchingChapter.content = mergeContent(matchingChapter.content, chapter.content);

        chapter.concepts.forEach((concept: any) => {
          const matchingConcept = matchingChapter.concepts.find(({ name }: any) => name === concept.name);
          if(!matchingConcept) {
            matchingChapter.concepts.push(concept);
            return;
          }
          // Merge concept content
          matchingConcept.content = mergeContent(matchingConcept.content, concept.content);
        })
      })
    });
  });
}

const mergeContent = (sourceContents: any[], contentsToMerge: any[]) => {
  const setOfContentIds = new Set();
  sourceContents.forEach(content => setOfContentIds.add(content.contentId));
  const result = [...sourceContents]
  contentsToMerge.forEach(content => !setOfContentIds.has(content.contentId) && result.push(content));

  return result;
}

const collectMilestoneTests = (phases:any) => {
  let tests:any[] = [];
  for (const phase of phases) {
    if (phase.milestoneTests.length) {
      const currTests = JSON.parse(JSON.stringify(phase.milestoneTests))
      tests = [...tests, ...currTests];
      phase.milestoneTests = [];
    }
  }
  return tests;
}

const distributeMilestoneTests = (primaryPhases:any, milestoneTests:any, packageEndDate: string, packageData: any) => {
  for (const test of milestoneTests) {
    let phaseIndex = getPhaseIndex(test.endDate, primaryPhases, packageData);
    if (!(phaseIndex === -1) && !isTestPresentInArray(test.name, primaryPhases[phaseIndex].milestoneTests)) {
      primaryPhases[phaseIndex].milestoneTests.push(test);
    } 
    else if(primaryPhases.length > 0 && phaseIndex === -1){
      const testStartDate = new Date(test.startDate).getTime();
      const testEndDate = new Date(test.endDate).getTime();
      const firstPhaseStartDate = new Date(primaryPhases[0].startDate).getTime();
      const lastPhaseStartDate = new Date(primaryPhases[primaryPhases.length - 1].startDate).getTime();
      const packageEndDateTime = new Date(packageEndDate).getTime();
      if((testEndDate >= lastPhaseStartDate) && (testEndDate <= packageEndDateTime)) {
        primaryPhases[primaryPhases.length - 1].milestoneTests.push(test);
      }

      if((testStartDate < firstPhaseStartDate) && !(isTestPresentInArray(test.name, primaryPhases[0].milestoneTests))) {
        primaryPhases[0].milestoneTests.push(test);
      }

    }  
  }
}


const collectMainOrExtraTests = (phases: any[], collectExtraTests: boolean) => {
  let tests:any[] = [];
  // const { phases:allPhases } = phases[0];
  
  for (const phase of phases) {
    if(collectExtraTests) {
      const { extraTests = [] } = phase;
      phase.extraTests = [];
      tests = tests.concat(extraTests)
    } else {
      for(const week of phase.weeks){
        const  { content = []} = week;
        week.content = []
        tests = tests.concat(content)
      }
    }
    
  }
  return tests;

}



export const distributeMainAndExtraTests = (tests: any[], phases: any[]) => {
  
  tests && tests.forEach((test:any, testIndex: number) => {
    let { startDate: testStartDate, endDate: testEndDate } = test;
    testStartDate = testStartDate ? new Date(testStartDate) : testStartDate;
    testEndDate = testEndDate ? new Date(testEndDate) : testEndDate;
    phases.forEach((phase:any, phaseIndex) => {
      const len = phases.length;
      let { startDate: phaseStartDate, endDate: phaseEndDate } = phase;

      phaseStartDate = phaseStartDate ? new Date(phaseStartDate) : phaseStartDate;
      phaseEndDate = phaseEndDate ? new Date(phaseEndDate) : phaseEndDate;

      phaseStartDate && phaseStartDate.setHours(0, 0, 0);
      phaseEndDate && phaseEndDate.setHours(23, 59, 59)

      let nextPhaseStartDate = phaseIndex !== len - 1 ? _.get(phases, `[${phaseIndex + 1}].startDate`, null) : null;
      
      nextPhaseStartDate = nextPhaseStartDate ? new Date(nextPhaseStartDate) : nextPhaseStartDate;
      nextPhaseStartDate && nextPhaseStartDate.setHours(0, 0, 0)
      
      
      const testIsInThisPhase = checkIfTestInThisPhase(
        testStartDate,
        testEndDate,
        phaseStartDate,
        phaseEndDate,
        nextPhaseStartDate
      )
      
      
      if(!testIsInThisPhase) return;
      let isTestAddedInAnyWeek = false;
      phase.weeks.forEach((week:any, weekIndex: number) => {
        if (isTestAddedInAnyWeek) return;

        let { startDate: weekStartDate, endDate: weekEndDate } = week;
        weekStartDate = weekStartDate ? new Date(weekStartDate) : weekStartDate;
        weekEndDate = weekEndDate ? new Date(weekEndDate) : weekEndDate;
        weekStartDate && weekStartDate.setHours(0, 0, 0);
        weekEndDate && weekEndDate.setHours(23, 59, 59);
        const isTestInThisWeek = checkIfMainTestInThisWeek(
          testStartDate,
          testEndDate,
          weekStartDate,
          weekEndDate
        )
        

        if(isTestInThisWeek){
          week.content.push(test);
          isTestAddedInAnyWeek = true;
        }

      })
      
      
      if(!isTestAddedInAnyWeek){
        phase.extraTests.push(test);
      }

    });
  }); 
}




const getIndex = (tree: any, subjectName: string) => {
  const subjects = tree.subjects;
  for (let i = 0; i < subjects.length; i++) {
    if (subjects[i].name === subjectName) return i;
  }
  return -1;
};

const getIndexInConflictedPhase = (phase: any, subjectName: string) => {
  const subjects = phase.subjects;
  const len = subjects.length;
  if (len) {
  for (let i = 0; i < len; i++) {
  if (subjects[i].name === subjectName) {
  return i;
  }
  }
  }
  return -1;
  };

  const buildSubjectArray = ( newConflictedPhase: any) => {

    newConflictedPhase.weeks.forEach((week: any) => {
      week.subjects.forEach((subject: any) => {
      let index = getIndexInConflictedPhase(newConflictedPhase, subject.name);
      if (index === -1) {
      newConflictedPhase.subjects.push({
      name: subject.name,
      id: subject.id,
      chapterCount: subject.chapters.length,
      });
      } else {
      newConflictedPhase.subjects[index].chapterCount += subject.chapters.length;
      }
      });
      });

  }